export const screenShortcut = [
    {
        "key_name": "F1",
        "screen_name":"OP Billing",
        "url": "payment/opbilling_format/list"
    },
    {
        "key_name": "F2",
        "screen_name":"Registration",
        "url": "patient-registration/patient_tab/list"
    },
    {
        "key_name": "F3",
        "screen_name":"Appointment",
        "url": "appointment/appointment_format/list"
    },
    {
        "key_name": "control.i",
        "screen_name":"IP Admission",
        "url": "adt/encounter_format/list"
    },
    /// ***********      Pharmacy module shortcuts    ***********///
    { 
        "key_name": "control.q",
        "screen_name":"Pharmacy",
        "url": "pharmacy/opCardLayout/list?tab_0=opOrder"
    },
    {
        "key_name": "control.y",
        "screen_name":"Pharmacy",
        "url": "/pharmacy/opCardLayout/list?tab_0=opDraftOrder"
    },
    {
        "key_name": "alt.a",
        "screen_name":"Pharmacy",
        "url": "/pharmacy/opCardLayout/list?tab_0=opBillList"
    },
    {
        "key_name": "alt.s",
        "screen_name":"Pharmacy",
        "url": "/pharmacy/opCardLayout/list?tab_0=opMedicationReturnList"
    },
    {
        "key_name": "alt.g",
        "screen_name":"Pharmacy",
        "url": "/pharmacy/opCardLayout/list?tab_0=due_settlement&p__no=0"
    },
    {
        "key_name": "alt.h",
        "screen_name":"Pharmacy",
        "url": "/pharmacy/opCardLayout/list?tab_0=pharmacy_due_settled&p__no=0"
    },
    {
        "key_name": "alt.q",
        "screen_name":"Pharmacy",
        "url": "/pharmacy/ipCardLayout/list?p__no=0"
    },
    {
        "key_name": "alt.w",
        "screen_name":"Pharmacy",
        "url": "/pharmacy/ipCardLayout/list?tab_0=cancelledOrderWorklist&p__no=0"
        
    },
    {
        "key_name": "alt.r",
        "screen_name":"Pharmacy",
        "url": "/pharmacy/ipCardLayout/list?tab_0=ipMedicationIssue&p__no=0"
    },
    {
        "key_name": "alt.t",
        "screen_name":"Pharmacy",
        "url": "/pharmacy/ipCardLayout/list?tab_0=pendingReturnRequest"
    },
    {
        "key_name": "alt.y",
        "screen_name":"Pharmacy",
        "url": "/pharmacy/ipCardLayout/list?tab_0=ipMedicationReturn"
    },
    {
        "key_name": "alt.u",
        "screen_name":"Pharmacy",
        "url": "/pharmacy/ipCardLayout/list?tab_0=ipSplitBill"
    },
    {
        "key_name": "alt.i",
        "screen_name":"Pharmacy",
        "url": "/pharmacy/ipCardLayout/list?tab_0=due_settlement"
    },
    {
        "key_name": "alt.o",
        "screen_name":"Pharmacy",
        "url": "/pharmacy/ipCardLayout/list?tab_0=settled&p__no=0"
    },
    {
        "key_name": "alt.p",
        "screen_name":"Pharmacy",
        "url": "/pharmacy/ipCardLayout/list?tab_0=ipMedicationSplitBillRefund"
    },
   
     /// ***********      Pharmacy module shortcuts end   ***********///

     ///*************************Inventory shortcut */
     {
        "key_name": "control.,",
        "screen_name":"Inventory",
        "url": "/inventory-management/scm_grnMaster/list"
    },
    {
        "key_name": "control./",
        "screen_name":"Inventory",
        "url": "/inventory-management/grn_return_layout/list"
    },
    {
        "key_name": "control.;",
        "screen_name":"Inventory",
        "url": "/inventory-management/stockLayout/list"
    },
    {
        "key_name": "control.'",
        "screen_name":"Inventory",
        "url": "/inventory-management/supplier/list"
    },
    {
        "key_name": "control.alt",
        "screen_name":"Inventory",
        "url": "/inventory-management/scm_grnMaster/add?returnUrl=%2Finventory-management%2Fscm_grnMaster%2Flist"
    }


     ///////********************END ***************************/
   
]